import React from 'react';

export interface Props {
  wrap?: boolean;
}

const NoScript: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  wrap = true,
}) => {
  return wrap ? <noscript>{children}</noscript> : <>{children}</>;
};
NoScript.displayName = 'NoScript';

export default NoScript;
